import * as React from 'react';
import styled from 'styled-components';
import { StyledInformationalPage } from '../../common/static.styles';
import { HeadTitle } from '../../components/head-title/HeadTitle';
import { DefaultLayout } from '../../layout/default/DefaultLayout';

// TODO: Add SEO props
const seo = {
  description: '',
};

const title = 'FAQs';

const StyledFAQPage = styled(StyledInformationalPage)`
  .faq-field:not(:last-of-type) {
    margin-bottom: 3.75em;
  }

  .faq-field-question {
    text-transform: none;
    font-size: 1rem;
    line-height: 1rem;
  }

  .faq-field-answer {
    font-size: 1rem;
  }
`;

// tslint:disable:max-line-length
// noinspection JSUnusedGlobalSymbols
export default () => (
  <DefaultLayout locale='pt-BR' seo={seo}>
    <HeadTitle title={title} />
    <StyledFAQPage>
      <div className='content'>
        <section>
          <h1>{title}</h1>
          <div className='faq-field'>
            <h2 className='faq-field-question'>O que é WarnerBros.com.br?</h2>
            <div className='faq-field-answer'>
              <p>
                É o seu site definitivo para tudo o que procura sobre a Warner Bros - filmes, televisão, home
                entertainment, games e mais.
              </p>
            </div>
          </div>
          <div className='faq-field'>
            <h2 className='faq-field-question'>Com quem posso fazer o licenciamento de stills e clips?</h2>
            <div className='faq-field-answer'>
              <p>
                Por favor entre em contato com{' '}
                <a href='mailto:licenciamento@warnerbros.com?subject=Licenciamento%20de%20stills%20e%20clips'>
                  licenciamento@warnerbros.com
                </a>
                .
              </p>
            </div>
          </div>
          <div className='faq-field'>
            <h2 className='faq-field-question'>Quem posso contactar para licenciar os produtos Warner?</h2>
            <div className='faq-field-answer'>
              <p>
                Por favor entre em contato com{' '}
                <a href='mailto:licenciamento@warnerbros.com?subject=Licenciamento%20de%20stills%20e%20clips'>
                  licenciamento@warnerbros.com
                </a>
                .
              </p>
            </div>
          </div>
          <div className='faq-field'>
            <h2 className='faq-field-question' id='sac'>
              SAC?
            </h2>
            <div className='faq-field-answer'>
              <p>Por favor contacte nosso SAC através do telefone 11 4004-2050.</p>
            </div>
          </div>
        </section>
      </div>
    </StyledFAQPage>
  </DefaultLayout>
);
